module.exports = __webpack_public_path__ + "static/media/sudoku-social.a42c73be.png";